export default "__VITE_ASSET__D76nvPdZ__"